module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "progressBar",
    staticClass: "progress-bar",
    on: {
      "click": _vm.progressClick
    }
  }, [_c('div', {
    staticClass: "bar-inner"
  }, [_c('div', {
    ref: "progress",
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    ref: "progressBtn",
    staticClass: "progress-btn-wrapper",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.progressTouchStart($event)
      },
      "touchmove": function($event) {
        $event.preventDefault();
        return _vm.progressTouchMove($event)
      },
      "touchend": _vm.progressTouchEnd
    }
  }, [_c('div', {
    staticClass: "progress-btn"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e78f22e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/progress-bar/progress-bar.vue
// module id = 572
// module chunks = 1